import { useI18n } from 'next-localization';
import PerformanceTableBase from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/Tables/PerformanceTableBase';
import { endpoints } from '../performanceEndpoints';

const AnnualizedQuarterlyTable = ({ className }: string) => {
  const { t } = useI18n();
  return (
    <PerformanceTableBase
      title={t('fundDetailsAnnualizedQuarterlyPerformanceTitle')}
      footnoteText={t('fundDetailsPerformanceCumulativeFootnote')}
      wrapperId="quarterlyAnnualizedWrapper"
      tableId="quarterlyAnnualizedTable"
      endpoint={endpoints.ANNUALIZED}
      className={className}
    />
  );
};

export default AnnualizedQuarterlyTable;
